export default __webpack_public_path__ + "static/media/img-guide-car-1@2x.bbaaf95f.png";